<mat-card>
  <mat-card-header>
    <mat-card-title>Page</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <ui-form-select [data]="bffEnvConfig()" formControlName="bffEnv"></ui-form-select>
      <ui-form-autocomplete [data]="pageRootConfig()" formControlName="pageId"></ui-form-autocomplete>
      <div class="triggers">
        <ui-form-checkbox
          (change)="onShowNavigationChange($event.checked)"
          [data]="showNavigationConfig()"
          formControlName="showNav"
        ></ui-form-checkbox>
        <ui-form-submit [data]="submitConfig"></ui-form-submit>
      </div>
    </form>
  </mat-card-content>
</mat-card>
